import { AcceptedResponseType } from '@atlassian/proforma-common-core/jira-common-apis';
export class LiveProjectFormApi {
  constructor(projectId, util) {
    this.projectId = projectId;
    this.util = util;
  }
  getForms() {
    return this.util.get(`/api/1/projects/${this.projectId}/forms`);
  }

  // public getFormsPaginated(
  //   pageSize: number,
  //   cursor?: string,
  // ): Promise<PagedResults<TemplateFormIndex>> {
  //   return this.util.get(
  //     `/api/2/projects/${this.projectId}/forms?pageSize=${pageSize}` +
  //       urlParam('cursor', cursor),
  //   );
  // }

  startXlsxDownload(templateFormId) {
    return this.util.post(`/api/2/reports/all-form-responses/${this.projectId}/${templateFormId}`, undefined);
  }
  checkXlsxDownload(templateFormId, taskId) {
    return this.util.get(`/api/2/reports/all-form-responses/${this.projectId}/${templateFormId}/${taskId}`);
  }
  downloadFinishedXlsx(templateFormId, taskId) {
    return this.util.get(`/api/2/reports/all-form-responses/${this.projectId}/${templateFormId}/${taskId}/ProForma-${this.projectId}-form-${templateFormId}.xlsx`, 'exportDownload', AcceptedResponseType.Blob);
  }
  deleteProjectForm(templateFormId) {
    return this.util.delete(`/api/1/projects/${this.projectId}/forms/${templateFormId}`);
  }
}